import { SET_CATEGORY, SET_ITEMS, SET_SELECTED, SET_INDEX_UPDATE_PREVIEW, SET_PREVIEW_POSITION } from '../constants/previewConstants';

export const previewInitState = {
    category: 'facebook',
    items: [],
    selected: [],
    index: undefined,
    previewPosition: []

};

const previewReducer = (state: any, action: any) => {
    switch (action.type) {
        case SET_CATEGORY:
            return {
                ...state,
                category: action.category
            }
        case SET_ITEMS:
            return {
                ...state,
                items: action.items
            }
        case SET_SELECTED:
            return {
                ...state,
                selected: action.selected
            }
        case SET_INDEX_UPDATE_PREVIEW:
            return {
                ...state,
                index: action.index
            }
        case SET_PREVIEW_POSITION:
            return {
                ...state,
                previewPosition: action.previewPosition
            }
        default:
            return { ...state };
    }
};

export default previewReducer;